import { render, staticRenderFns } from "./HoldingPositionValueChart.vue?vue&type=template&id=19d69954&"
import script from "./HoldingPositionValueChart.vue?vue&type=script&lang=ts&"
export * from "./HoldingPositionValueChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
